"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var pax_1 = require("./pax");
var State = /** @class */ (function () {
    function State() {
        this.paxe = [new pax_1.PaxElement(true), new pax_1.PaxElement(false)];
        this.allFieldsValid = false;
        this.erpFieldsValid = false;
        this.formValidations = {};
        this.departureDate = '';
        this.transportationType = '';
        this.checkPaxChildAge = false;
    }
    return State;
}());
exports.State = State;
//# sourceMappingURL=state.js.map